const getDeviceInfoDetails = () => {
  // User agent and platform
  const userAgent = navigator.userAgent || window.opera;
  let platform = 'Unknown';
  let browser = 'Unknown';
  let isAndroid = false;

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    platform = 'iOS';
  } else if (/android/i.test(userAgent)) {
    platform = 'Android';
    isAndroid = true;
  } else if (/windows/i.test(userAgent)) {
    platform = 'Windows';
  }

  if (/edge/i.test(userAgent) || /edg/i.test(userAgent)) {
    browser = 'Edge';
  } else if (/chrome/i.test(userAgent)) {
    browser = 'Chrome';
  } else if (/safari/i.test(userAgent) && !/chrome/i.test(userAgent)) {
    browser = 'Safari';
  } else if (/firefox/i.test(userAgent)) {
    browser = 'Firefox';
  } else if (/opr/i.test(userAgent)) {
    browser = 'Opera';
  }

  // Device memory (in GB, approximate)
  const deviceMemory = navigator.deviceMemory ? `${navigator.deviceMemory}GB` : 'Unknown';

  // Available memory (Approximation)
  const availableMemory = window.performance && window.performance.memory ?
    `${(window.performance.memory.totalJSHeapSize / 1024 / 1024).toFixed(1)}MB` : 'Unknown';

  // Screen size (inches)
  const screenSize = `${Math.sqrt(
    Math.pow(window.screen.width / window.devicePixelRatio, 2) +
    Math.pow(window.screen.height / window.devicePixelRatio, 2)
  ).toFixed(1)} inches`;

  // Check if cookies are enabled
  const cookiesEnabled = navigator.cookieEnabled ? 'Enabled' : 'Disabled';

  // Check if Flash is supported
  const flashSupport = typeof navigator.plugins['Shockwave Flash'] !== 'undefined' ? 'Yes' : 'No';

  // Get JavaScript heap size (approximation)
  const jsHeapSize = window.performance && window.performance.memory ?
    `${(window.performance.memory.jsHeapSizeLimit / 1024 / 1024).toFixed(1)}MB` : 'Unknown';

  // Browser version
  let browserVersion = 'Unknown';
  // const browserMatch = userAgent.match(/(chrome|safari|firefox|edge|opr)[\/\s](\d+)/i);
  const browserMatch = userAgent.match(/(chrome|safari|firefox|edge|opr)[/\s](\d+)/i);
  if (browserMatch) {
    browserVersion = browserMatch[2];
  }

  // System version extraction (iOS/Android)
  let systemVersion = 'Unknown';
  const iOSMatch = userAgent.match(/OS (\d+_\d+)/i);
  const androidMatch = userAgent.match(/Android (\d+\.\d+)/i);
  if (iOSMatch) {
    systemVersion = iOSMatch[1].replace('_', '.');
  } else if (androidMatch) {
    systemVersion = androidMatch[1];
  }

  const isMobileApp = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.includes("com.vagaro.iospro") || userAgent.includes("com.vagaro.androidpro") || userAgent.includes("com.vagaro.customerios") || userAgent.includes("com.vagaro.customer")) {
      return true;
    }
    return false;
  };

  // Assemble the final details object
  return {
    deviceMemory,
    availableMemory,
    deviceModelName: 'Unknown', // Needs to be manually set or detected with custom logic.
    webUserAgent: userAgent,
    proVersionNumber: '1.0.0', // Placeholder, modify as needed.
    customerAppVersionNumber: '2.3.1', // Placeholder, modify as needed.
    browserName: browser,
    browserVersion,
    systemName: platform,
    systemVersion,
    systemSpecification: '64-bit', // Assuming modern browsers and OSes are 64-bit.
    screenSize,
    mobile: /Mobi|Android/i.test(userAgent) ? 'Yes' : 'No',
    flash: flashSupport,
    cookies: cookiesEnabled,
    jsHeapSize,
    isAndroid,
    isMobileApp,
  };
};
export { getDeviceInfoDetails };